import cn from 'bem-cn';

import { Stack } from '../UI';

import { ChallengeInfoHeader } from './ChallengeInfoHeader';
import { ChallengeInfoBody } from './ChallengeInfoBody';
import { ChallengeInfoFooter } from './ChallengeInfoFooter';
import { ChallengeInfoRules } from './ChallengeInfoRules';
import { ChallengeInfoProps } from './ChallengeInfo.types';
import './ChallengeInfo.scss';

const b = cn('challenge-info');

export const ChallengeInfo = (props: ChallengeInfoProps) => {
    const { challenge, courses } = props;

    return (
        <Stack className={b()}>
            <ChallengeInfoHeader challenge={challenge} />
            <ChallengeInfoBody challenge={challenge} />
            <ChallengeInfoFooter courses={courses} />
            <ChallengeInfoRules />
        </Stack>
    );
};
